import copy from "~/directives/copy/index";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("copy", copy);
});
